import { apiClient, invalidateCsrfToken } from "@/lib/apiClient";

export type SignInPayload = {
  organizationId: string;
  username: string;
  password: string;
};

/** Authentication is cookie-based: the session lands in an httpOnly cookie. */
export async function signIn(payload: SignInPayload): Promise<unknown> {
  const response = await apiClient.post("auth/signin", payload);
  // The API rotates the CSRF token after sign-in, so discard the pre-login token.
  invalidateCsrfToken();
  return response;
}

export async function signOut(): Promise<unknown> {
  try {
    return await apiClient.post("auth/signout");
  } finally {
    invalidateCsrfToken();
  }
}
